import { graphql } from 'gatsby';
import { createGatsbyPageComponent } from '@shapeable/ui';
export default createGatsbyPageComponent('Page');

export const QUERY = graphql`
query PageQuery($id: ID!) {
  platform { page(id: $id) {
    id name slug typeLabel badge path updated __typename _schema { label pluralLabel }  
    title 
    pretitle
    subtitle
    titleRich { text }
    subtitleRich { text }
    published
    content { text }
    options { text }
    openGraph { title description { plain } image { thumbnails { full { url } } } }
    intro { plain text }
    outro { text }
    themeMode { slug }
    orderNumber
    layout {
      id name slug component 
    }
    videos {
      id name url
      thumbnail { id url static { childImageSharp { gatsbyImageData } } }
    }
    imageAssets {
      id name image { id url type static { childImageSharp { gatsbyImageData } } }
    }
    people {
      id name slug path
      organisation { id name }
      linkedin
      position
      photo { id url type static { childImageSharp { gatsbyImageData } } }
    }
    embeds {
      citations {
        slug url name authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year
      }
      pages {
        id name slug path
        openGraph {
          title description { plain }
          image { url type static { childImageSharp { gatsbyImageData(placeholder: NONE) } } }
        }
      }
      people {
        id name slug path
        organisation { id name }
        position
        photo { id url }
      }
      imageAssets {
        id
        slug
        image {
          id url type width height static { childImageSharp { gatsbyImageData(placeholder: NONE) } } 
        }
      }
    }
    bannerLinks {
      id name slug url __typename
      label
    }
    parent {
      __typename id name path slug title subtitle pretitle 
      content { text }
      children {
        __typename id name path slug title subtitle pretitle 
        openGraph { description { text } }
        intro { text }
        orderNumber
        banner {
          name slug alternateText
          thumbnail { 
            id url width height static { childImageSharp { gatsbyImageData(placeholder: NONE) } } 
          }
        }
      }
    }
    
    children {
      __typename id name path slug title subtitle pretitle 
      openGraph { description { text } }
      intro { text }
      orderNumber
      banner {
        name slug alternateText
        thumbnail { 
          id url width height static { childImageSharp { gatsbyImageData(placeholder: NONE) } } 
        }
      }
    }
    banners {
      id name slug title description { text } alternateText
      image { 
        id url type width height static { childImageSharp { gatsbyImageData(placeholder: NONE) } } 
      }
    }
    slices {
      id name slug 
      title
      disabled
      created updated
      outro { text }
      intro { text }
      titleRich { text }
      subtitleRich { text }
      themeMode { slug }
      images {
        id name slug alternateText description { text }
        image { 
          id url type width height static { childImageSharp { gatsbyImageData(placeholder: NONE) } } 
        }
      }
      pages {
        id name path disabled
      }
      people {
        __typename
        id name slug 
        photo { url type static { childImageSharp { gatsbyImageData } } grayscale { id url static { childImageSharp { gatsbyImageData } } } }
        position
        bio { text html(links: { target: "_blank" }) }
        linkedin
        organisation { id name }
      }
      links {
        id name url page { path }
      }
      options { text }
      files {
        id
        name
        slug
        file {
          id
          url
        }
        thumbnail {
          url
          static {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      videos { 
        url 
        openGraph {
          image { url type static { childImageSharp { gatsbyImageData(placeholder: NONE) } } }
        }
      }
      color { value }
      backgroundColor { value }
      backgroundImages {
        image {
          url
        }
      }
      blocks {
        id name slug 
        title 
        titleRich { text }
        subtitle
        subtitleRich { text }
        link { id url name page { path } }
        page { id path name }
        links { id url name page { path } }
        pages { id name }
        content { text }
        options { text }
        image { id name image { url type static { childImageSharp { gatsbyImageData } } } }
      }
      content { text }
      image { id }
      layout { id name slug component }
      organisations {
        id
        name
        url
        logoInverted { type url }
        logo { type url }
      }
    }
  } }
}
`;
